import { render, staticRenderFns } from "./VMSelect.vue?vue&type=template&id=03ecccb8&lang=pug&"
import script from "./VMSelect.vue?vue&type=script&lang=js&"
export * from "./VMSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports